// import React, { useEffect, useRef, useState } from "react";
import "./Section9.scss";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const Section9 = () => {
  // const emailRef = useRef(null);
  // const rectRef = useRef(null);
  // const spotlightSize = 100;
  // const [email, setEmail] = useState("");

  // const updateRect = () => {
  //   if (emailRef.current) {
  //     rectRef.current = emailRef.current.getBoundingClientRect();
  //   }
  // };

  // useEffect(() => {
  //   updateRect();
  //   window.addEventListener("resize", updateRect);
  //   window.addEventListener("scroll", updateRect);

  //   let ticking = false;

  //   const onMouseMove = (e) => {
  //     if (!rectRef.current || !emailRef.current) return;

  //     if (!ticking) {
  //       requestAnimationFrame(() => {
  //         const rect = rectRef.current;

  //         // spotlight position RELATIVE to input
  //         const x = e.clientX - rect.left - spotlightSize / 2;
  //         const y = e.clientY - rect.top - spotlightSize / 2;

  //         if(emailRef && emailRef.current)
  //         {
  //           emailRef.current.style.backgroundPosition = `${x}px ${y}px`;
  //         }

  //         ticking = false;
  //       });

  //       ticking = true;
  //     }
  //   };

  //   document.addEventListener("mousemove", onMouseMove);

  //   return () => {
  //     document.removeEventListener("mousemove", onMouseMove);
  //     window.removeEventListener("resize", updateRect);
  //     window.removeEventListener("scroll", updateRect);
  //   };
  // }, []);

  // const formLink = "https://cloud.exdnow.com/s/2RqAqAwdH8yPmmg";

  // const handleClick = () => {
  //   setEmail("");
  //   const popup = window.open(formLink, "_blank");
  //   if (popup) {
  //     popup.opener = null;
  //     popup.location.href = formLink;
  //     popup.focus();
  //   } else {
  //     alert("Pop-up blocked. Please enable pop-ups.");
  //   }
  // };

  return (
    <section className="home-section-9">
      <div className="container sect-9-container" data-aos="fade-in" data-aos-duration="1000">
        <h5 className="header">Keep Calm and Go Digital!</h5>

        {/* <div className="content">
          <p>Keep Calm and Go Digital!!</p>
        </div> */}

        {/* <form className="sub-form" onSubmit={(e) => e.preventDefault()}>
          <input
            ref={emailRef}
            type="email"
            className="email-field"
            placeholder="Enter your email address"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <button type="button" className="btn" onClick={handleClick}>
            <span className="btn-link">Sign Up!</span>
          </button>
        </form> */}
        <Link to="/contact-us#contact-form" className="btn quote-btn">
          Get a Quote
        </Link>
      </div>
    </section>
  );
};

export default Section9;
